












import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

import iwTextarea from "@/encoding/components/buildingBlocks/Textarea.vue";

export default Vue.extend({

    components: {
        iwTextarea: iwTextarea,
    },

    data: function() {
        return {
            specificId: uuidv4() as string,
        };
    },

    methods: {
        updateInfo: function(info: string) {
            this.$emit("update", info);
        },
    },

});
